export const CONTACT_US_PHONE_NUMBER = "+91-9962275767";
export const CONTACT_US_EMAIL = "incontactcollective@gmail.com";
